"use strict";
var paginator_controller_1 = require("./paginator.controller");
var templateUrl = require("./paginator.html");
exports.paginator = {
    templateUrl: templateUrl,
    controller: paginator_controller_1.PaginatorController,
    controllerAs: "vm",
    bindToController: true,
    scope: {
        oddNumberOfPagesToShow: "=",
        pages: "=",
        currentPage: "=",
        onSetPage: "&"
    }
};



/** WEBPACK FOOTER **
 ** ./app/common/paginator/paginator.ts
 **/